import React from 'react';
import { ChevronDown } from 'lucide-react';

interface SyChevronProps {
    expanded: boolean;
    onToggle: (e?: React.KeyboardEvent | React.MouseEvent) => void;
    ariaControls?: string;
    title?: string;
    iconClassName?: string;
}

const SyChevron: React.FC<SyChevronProps> = ({ expanded, onToggle, ariaControls, title, iconClassName }) => {
    return (
        <button
            aria-expanded={expanded}
            aria-controls={ariaControls}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => onToggle && onToggle(e)}
            onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => onToggle && onToggle(e)}
            style={{
                background: 'transparent',
                border: 'none',
                padding: 0,
                width: 16,
                height: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                marginRight: 0,
            }}
            title={title}
        >
            <ChevronDown
                size={16}
                className={iconClassName}
                style={{ transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)' }}
            />
        </button>
    );
};

export default SyChevron;
